<script>
    //import "inter-ui/inter.css";
    import Splash from "./Splash.svelte";
    import First from "./First.svelte";
    import Second from "./Second.svelte";
    import Third from "./Third.svelte";
    import Fourth from "./Fourth.svelte";
    import Paper from "./Paper.svelte";
    import { AppBar, Button, Icon, Menu, ListItem } from "svelte-materialify/src";
    import { mdiDotsVertical } from "@mdi/js";

    //let theme = 'light';

    //const views = {"1": First, "2": Second, "3": Third, "4": Fourth, "5": Paper}
    const views = { "1": First, "2": Second, "3": Third, "4": Fourth, "5": Paper, "0": Splash };

    let show = 0;
</script>

<svelte:component this={views[show]}>
    <AppBar fixed class="theme--dark" style="width: 100%;">
        <!-- <div slot="icon">
            <Button fab depressed>
                <Icon path={mdiMenu}></Icon>
            </Button>
        </div> -->
        <span slot="title"> AccessibilityExplorer </span>
        <div style="flex-grow:1" />
        <Menu right>
            <div slot="activator">
                <Button fab depressed>
                    <Icon path={mdiDotsVertical} />
                </Button>
            </div>
            <ListItem on:click={() => (show = 1)}>By CVD or Track</ListItem>
            <ListItem on:click={() => (show = 2)}>UMAP Projection</ListItem>
            <ListItem on:click={() => (show = 3)}>Correlation Matrix</ListItem>
            <!-- <ListItem on:click={() => show = 4}>Comments Projection</ListItem>
            <ListItem on:click={() => show = 5}>Visualizations for the paper</ListItem> -->
        </Menu>
    </AppBar>
</svelte:component>

<!-- <style>
    :global(html) {
        font-family: "Inter", "system-ui";
    }

    @supports (font-variation-settings: normal) {
        :global(html) {
            font-family: "Inter var", "system-ui";
        }
    }
</style> -->

<style lang="scss" global>
    $primary-color: #ff3e00 !default;
    $primary: #ff3e00;
    $secondary-color: #ddd !default;
    $secondary: #ddd;
    $mdc-theme-secondary: #676778;

    @use "inter-ui/default" with (
        $inter-font-display: swap,
        $inter-font-path: "inter-ui/Inter (web)"
    );
    @use "inter-ui/variable" with (
        $inter-font-display: swap,
        $inter-font-path: "inter-ui/Inter (web)"
    );
    @include default.all;
    @include variable.all;

    :global(*) {
        font-family: "Inter", "system-ui" !important;
    }

    @supports (font-variation-settings: normal) {
        :global(*) {
            font-family: "Inter var", "system-ui" !important;
        }
    }
</style>